import React from 'react';

const Tags = ({ className, label }) => {
	return <span className={`status ${className}`}>{label}</span>;
};

export default Tags;
